<template>
  <div class="" v-if="item">
    <div class="row my-3">

      <div class="col col-md-12">
        <div class="form-group">
          <label class='control-label pr-2'>Дата создания:</label>
          <span>{{ $momentFormat(item.created, "DD.MM.YYYY HH:mm") }}</span>
        </div>
      </div>

      <div class="col col-md-12">
        <div class="form-group">
          <label class='control-label pr-2'>Дата прохождения:</label>
          <span>{{ $momentFormat(item.dateEnter, "DD.MM.YYYY HH:mm") }}</span>
        </div>
      </div>


      <div class="col  col-md-12">
        <div class="form-group">
          <label class='control-label'>Образовательные учреждения</label>
          <div ><textarea :disabled="isReadonly" class="form-control" v-model="item.educationalInstitutions"/></div>

        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label class='control-label'>Учреждения доп. образования</label>
          <div ><textarea :disabled="isReadonly" class="form-control" v-model="item.educationalAddInstitutions"/></div>

        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label class='control-label'>Запрос к специалистам</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.requestSpecialists"/></div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Навыки самообслуживания</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.selfServiceSkills"/>
          </div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Игровая деятельность</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.playActivity"/></div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Восприятие</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.perception"/></div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div  class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Двигательно-моторное развитие</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.motorDevelopment"/>
          </div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Речевое развитие</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.language"/></div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Коммуникация</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.communication"/>
          </div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Познавательная деятельность</label>
          <div ><textarea :disabled="isReadonly" class="form-control" v-model="item.cognitiveActivity"/>
          </div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group required">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Рекомендовано</label>
          <div><textarea :disabled="isReadonly" class="form-control" required="required" v-model="item.recommend"/></div>
          <div class="invalid-msg" v-if="v$.item.recommend.$error">Введите данные</div>
        </div>
      </div>
      <div class="col  col-md-12">
        <div class="form-group">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Дополнительная информация</label>
          <div><textarea :disabled="isReadonly" class="form-control" v-model="item.dopInfo"/></div>
        </div>
      </div>

      <div class="col col-md-12">
        <div class="form-group required">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Организация</label>

            <Select2
                :disabled="isReadonly"
                class="select2"
                :options="organizationList"
                v-model="item.organizationId"
                v-on:select="loadEmployees()"
                style="width: 100%"
                id="selectOrganization"
            />


          <div class="invalid-msg" v-if="v$.item.organizationId.$error">Введите данные</div>
        </div>
      </div>

      <div class="col  col-md-12">
        <div class="form-group required">
          <label :class="{'form-check--none': isReadonly}" class='control-label'>Специалисты</label>
            <!-- <Select2
                :disabled="isReadonly"
                multiple="true"
                :settings="{multiple: true}"
                :options="employeeList"
                v-model="item.employeeIds"
                style="width: 100%"
                id="selectEmployee"
            /> -->
          <div><input :disabled="isReadonly" class="form-control" v-model="item.specialists" /></div>
          <div class="invalid-msg" v-if="v$.item.specialists.$error">Введите данные</div>
        </div>
      </div>

      <div class="col col-md-12">
                <div class="form-group">
                  <label class='control-label'>Копия заключения</label>
                  <file-upload width="100%" :entity="item"
                    @deleteFile="removeFile"
                    prop-name="file"
                    @uploaded="fileUploaded"/>
                </div>
              </div>

      <div class="col col-md-12" v-if="item.dateApproved">
        <div class="form-group">
          <label class='control-label pr-2'>Дата утверждения:</label>
          <span>{{ $momentFormat(item.dateApproved, "DD.MM.YYYY HH:mm") }}</span>
        </div>
      </div>

    </div>


    <div>
      <div class="float-right d-flex align-items-center">
        <button-component class="btn btn-primary mx-2 btn-sm" v-if="!isReadonly" v-on:click="save">Сохранить
        </button-component>
        <button-component type="button" kind="secondary" class="btn btn-default btn-sm" v-on:click="close">Закрыть
        </button-component>
      </div>
    </div>

  </div>
</template>
<script>
import API from '../api/diagnostic'
import Constants from '../../../common/constants'
import {required} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import ButtonComponent from "../../../common/ui/ButtonComponent";
import FileUpload from "@/common/components/FileUpload";
import UserApi from '@/modules/admin/api/users';

const selectValidator = (value) => value > 0;

export default {
  name: "DiagnosticCard",
  components: {ButtonComponent, FileUpload},
  props: {
    cardId: {
      type: Number,
      required: false,
      default: null
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.loadPage();
    this.loadOrganizations();
  },
  data() {
    return {
      item: {
        organizationId: null,
        employeeIds: [],
        file: null
      },

      organizationList: [],
      employeeList: []
    };
  },
  methods: {
    loadEmployees() {
      return;

      // var self = this;
      // if (self.item.organizationId) {
      //   API.loadEmployees(self.item.organizationId).then((response) => {
      //     self.employeeList = response.data;
      //     $("#selectEmployee").trigger("change");
      //   });
      // } else {
      //   self.employeeList = [];
      //   $("#selectEmployee").trigger("change");
      // }
    },
    loadOrganizations() {
      API.loadOrganizations("").then((response) => {
        this.organizationList = response.data;
        //$("#selectOrganization").trigger("change");
      });
    },
    loadPage() {
      if (this.cardId)
        API.find(this.cardId).then(response => {
          this.item = response.data;
          this.item.employeeIds = [];
          // if (self.item.journalDiagnosticSpecialists) {
          //   self.item.journalDiagnosticSpecialists.forEach(function (n) {
          //     self.item.employeeIds.push(n.employeeId);
          //   });
          // }

          if(!this.item.organizationId) {
            UserApi.currentUserOrgs().then((res) => {
              if(res.data && res.data.length > 0) {
                var id = res.data[0].id;
                if(id > 0) {
                  this.item.organizationId = id;
                }
              }
            });
          }
          //self.loadEmployees();
        });
    },
    save() {
      var self = this;

      self.v$.$touch();
      if (self.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      self.item.journalDiagnosticSpecialists = [];
      // if (self.item.employeeIds) {
      //   self.item.employeeIds.forEach(function (n) {
      //     self.item.journalDiagnosticSpecialists.push({employeeId: n});
      //   });
      // }

      API.save(self.item).then(function (response) {
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          self.$emit('save');
        }
      });
    },
    close() {
      this.$emit('close');
    },

    organizationName() {
      var name = "";
      var self = this;
      var org = self.organizationList.find(x => x.id == self.item.organizationId);
      if (org)
        name = org.text;
      return name;
    },
    employeeNames() {
      var name = [];
      var self = this;
      if (self.item.employeeIds) {
        self.item.employeeIds.forEach(function (n) {
          var empl = self.employeeList.find(x => x.id == n);
          if (empl)
            name.push(empl.text);
        });
      }

      return name.join("; ");
    },

    fileUploaded(e) {
        this.item.file = e.data;
    },
    removeFile() {
      this.item.fileId = null;
      this.item.file = null;
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        organizationId: {required, selectValidator},
        //selfServiceSkills: {required},
        //playActivity: {required},
        //perception: {required},
        //motorDevelopment: {required},
        //language: {required},
        //communication: {required},
        //cognitiveActivity: {required},
        recommend: {required},
        //employeeIds: {required},
        specialists: {required},
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.select2::v-deep {
  .select2-container {
    width: 100% !important;
    max-width: 100% !important;

  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;

  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 7px !important;
  }
}

.form-group.required .control-label:after {
  content: "*";
  color: red;
}
.form-group.required .form-check--none.control-label:after {
  content: "";
  color: transparent;
}


.invalid-msg {
  color: red;
  font-size: 0.75rem;
}
</style>
<style lang="scss">
.w100 .select2-container {
  width: 100% !important;
}

.select2-container--open {
  z-index: 2000;
}
</style>